import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { download } from "../../../functions/download";
import { errorDispatch } from "../../../functions/errorDispatch";
import { setDocTitle } from "../../../functions/HelperFuncs";
import i18n from "../../../functions/i18next.js";

export default {
  data() {
    return {
      id: this.$options.name,
      files: [],
      doneSearching: false,
      selectedFiles: [],
      selectedFolders: [],
      collectionId: this.$route.params.id,
      actionBtns: {},
      name: "",
    };
  },
  created() {
    this.setActionBtns();

    this.getFiles();

    this.addBtnListeners();

    EventBus.$on(`${this.id}-update`, () => {
      this.getFiles();
    });

    EventBus.$on(`files-holder-update`, (data) => {
      //update selected files and folders
      Object.keys(data).forEach((key) => {
        if (data[key] && this[key]) {
          this[key] = data[key];
        }
      });
    });

    setDocTitle("Collection detail", this);
  },
  methods: {
    addBtnListeners() {
      [...this.actionBtns.defaultBtns, ...this.actionBtns.selectedBtns].forEach(
        (btn) => {
          EventBus.$on(btn.emitterName, (e) => {
            if (btn.func) {
              btn.func(e);
            } else {
              this.openRightSidebar(
                btn.emitterName.substring(btn.emitterName.lastIndexOf("-") + 1),
                {
                  collectionId: this.collectionId,
                }
              );
            }
          });
        }
      );
    },
    openRightSidebar(id, data) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: data,
      });
    },
    setActionBtns() {
      this.actionBtns = {
        defaultBtns: [
          {
            name: i18n.t("collection.rename_collection"),
            icon: "rename",
            emitterName: `${this.id}-renameCollection`,
            rights: ["collect"],
            func: (e) => this.renameCollection(e),
          },
          {
            name: i18n.t("collection.download_collection"),
            icon: "download",
            emitterName: `${this.id}-downloadCollection`,
            rights: ["download_folders", "download_files"],
            func: (e) => this.downloadCollection(e),
            disabled: () => this.collectionHasItems(),
          },
          {
            name: i18n.t("collection.transfer_collection"),
            icon: "transfer",
            emitterName: `${this.id}-transfer`,
            rights: ["tranfser_folder", "transfer_files"],
            func: (e) => this.transferCollection(e),
            disabled: () => this.collectionHasItems(),
          },
          {
            name: i18n.t("collection.delete_collection"),
            icon: "delete--alt",
            emitterName: `${this.id}-deleteCollection`,
            func: () => this.deleteCollection(),
            rights: ["collect"],
          },
        ],
        selectedBtns: [
          {
            name: i18n.t("common.remove"),
            icon: "delete--alt",
            emitterName: `${this.id}-deleteCollectionItem`,
            rights: ["collect"],
            func: () => this.deleteCollectionItem(),
            useMySpace: true,
            showOnMySpace: true,
          },
        ],
      };
    },
    renameCollection() {
      this.openRightSidebar("rename", {
        id: this.collectionId,
        name: this.name,
        type: "collection",
      });
    },
    deleteCollectionItem() {
      this.openRightSidebar("deleteCollectionItem", {
        collectionId: this.collectionId,
      });
    },
    collectionHasItems() {
      //has files
      return this.files.length <= 0;
    },
    transferCollection() {
      this.openRightSidebar("transfer", { collectionId: this.collectionId });
    },
    deleteCollection() {
      this.openRightSidebar("deleteCollection", {
        collectionId: this.collectionId,
      });
    },
    createDownloadLink() {
      return `${baseUrl}/collectiondownload?collection=${
        this.collectionId
      }&company=${this.$store.state.company}${
        this.$store.state.user ? `&key=${this.$store.state.user.key}` : ""
      }`;
    },

    downloadCollection(e) {
      download(
        {
          type: "collection",
          item: this.collectionId,
          btn: e.event.currentTarget,
        },
        this
      ).catch((error) => {
        errorDispatch("dowload_collection");
      });
    },
    openRightSidebar(id, extraData = {}) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: { ...extraData },
      });
    },
    openFileIfPresent() {
      const fileId = this.$route.params.file;

      if (fileId) {
        this.$axios
          .get(`${baseUrl}/file?file=${fileId}&myspace=${this.mySpace}`, {
            responseType: "json",
          })
          .then((r) => {
            setDocTitle(r.data.name, this);

            EventBus.$emit(`right-sidebar-show`, {
              id: "file",
              data: r.data,
            });
          });
      }
    },

    getFiles() {
      this.doneSearching = false;

      this.collectionId = this.$route.params.id;
      this.$axios
        .get(`${baseUrl}/collection/${this.collectionId}`, {
          responseType: "json",
        })
        .then((r) => {
          this.name = r.data.collectionData.name;

          setDocTitle(`Collection - ${this.name}`, this);
          this.files = r.data.items;

          this.doneSearching = true;

          this.openFileIfPresent();
        });
    },
    checkUrlForBigChanges() {
      return this.$route.path.includes(
        `/${this.$store.state.company}/collection/expanded/${this.collectionId}`
      );
    },
  },
  watch: {
    $route() {
      if (!this.checkUrlForBigChanges()) {
        //big url change so reload the files
        this.getFiles();
      }
    },
  },
};
